import "../Sass/styles.scss";
import "jquery/dist/jquery.slim";
import "slick-carousel/slick/slick";
import "lightcase/src/js/lightcase";

jQuery(document).ready(function($) {
    $("a[data-rel^=lightcase]").lightcase({
        transition: "scrollHorizontal",
        slideshow: true,
        shrinkFactor: 0.9,
        //disableShrink: true
    });
});

function slickInitialise() {
    $(".slick").slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        adaptiveHeight: true
    });
}
slickInitialise();

// sticky header

const $header = $(".header");
const $menuToggle = $(".menu-toggle");
const $goTopLink = $("#js-go-top");

$menuToggle.click( (event) => {
    $("body").toggleClass("menu-opened");
    $(event.currentTarget).toggleClass("is-active");
    $(".menu__wrapper").toggleClass("menu__wrapper--opened");
});

$(window).scroll( (event) => {
    let scrollTop = $(window).scrollTop();

    if (scrollTop > 150) {
        $header.addClass("header--small");
    } else {
        $header.removeClass("header--small");
    }

    // scroll to top link show / hide
    if (scrollTop > 400) {
        $goTopLink.addClass("go-top--visible");
    } else {
        $goTopLink.removeClass("go-top--visible");
    }
});

// scroll to top

(function() {
    let ScrollTop = {
        Init : function(ele, opts) {
            // Variable Initial
            this.$top = ele;
            this.duration = (opts && opts.duration) || 400 ;

            // Event scroll
            ScrollTop.Event();
        },

        Event : function() {
            this.$top.addEventListener("click", function(e) {

                // Shortcut
                let docElement = document.documentElement,
                    requestAnimationFrame = window.requestAnimationFrame
                        || function(callback) { return window.setTimeout(callback, 1000/60) },

                    cancelAnimationFrame = window.cancelAnimationFrame
                        || window.clearTimeout;

                // Get position-top and timer at begin
                let yBegin = (window.pageYOffset || docElement.scrollTop) - (docElement.clientTop || 0),
                    yEnd   = 0,
                    tBegin = +new Date(),
                    n = 0,
                    yCur, yEasing, timeCur, request;

                // Iteration
                function step() {
                    n++;
                    timeCur = (+new Date() - tBegin) / ScrollTop.duration;
                    yCur = (1 - timeCur) * yBegin;
                    yEasing = ScrollTop.Easing.easeOutQuad(null, +new Date() - tBegin, 0, 1, ScrollTop.duration);
                    let yCur2 = (1 - yEasing) * yBegin;

                    // console.log(+new Date() - tBegin);
                    // console.log(yCur +' --------- '+ yCur2);

                    // Make "yCur" always >= 0
                    if( yCur < 0 ) yCur = 0;
                    if( 0 < yCur2 && yCur2 < 1 ) yCur2 = 0;

                    // Window ScrollTo
                    window.scrollTo(0, yCur2);

                    // Request Animation Frame -> make loop
                    request = requestAnimationFrame(step);

                    // Cancel Animation Frame
                    if( yCur <= yEnd ) cancelAnimationFrame(request);
                }
                step();

                // Don't scrolltop with href="#"
                e.preventDefault ? e.preventDefault() : e.returnValue = false;
            });
        },

        /**
         * Easing for Animation
         * Copyright : Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
         */
        Easing : {
            // Variable
            // x: percent (null)
            // t: current time (ms)
            // b: beginning value (gia tri 0)
            // c: change in value (gia tri 1)
            // d: duration (ms)
            easeOutQuad: function (x, t, b, c, d) {
                return -c *(t/=d)*(t-2) + b;
            }
        }
    };


    /**
     * CREATE NEW PLUGIN BY:
     *  new ScrollTop(element, options)
     */
    window.ScrollTop = function() {
        ScrollTop.Init(arguments[0], arguments[1]);
        return ScrollTop;
    }
}());

document.addEventListener("DOMContentLoaded", function() {
    let scrollToTopElementId = document.getElementById("js-go-top");
    new ScrollTop(scrollToTopElementId, {});
});

$(function() {
    $("a[href*=\\#]:not([href=\\#])").click(function() {
        if (location.pathname.replace(/^\//,"") === this.pathname.replace(/^\//,"") && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
                $("html,body").stop(true,true).animate({
                    scrollTop: target.offset().top-10, scrollLeft:target.offset().left-10
                }, 750);
                return false;
            }
        }
    });
});
